/**
 * Programs Translations Module (French)
 * @module programs
 * @language fr
 */

export const programs = {
  programsEventsPage: { pageSubtitle: "JCI RISE • CYE • JIB • Débat • Prise de Parole • Conférences 2024-2025" },
  programs: {
    flagshipPrograms: "Programmes Phares",
    programDataMetrics: "Données d'impact réel du Rapport d'Impact JCI 2025",
    coreInitiative: "Initiative Principale",
    jciRise: "JCI RISE",
    riseQuote: "Reconstruire les communautés, Inspirer l'action, Soutenir l'impact, Autonomiser les jeunes",
    totalProjects: "Total des Projets",
    beneficiaries: "Bénéficiaires",
    volunteerHours: "Heures de Bénévolat",
    localOrganizations: "Organisations Locales",
    countries: "Pays",
    projects: "projets",
    economicRecovery: "Reprise Économique",
    workforceReadiness: "Préparation de la Main-d'œuvre",
    mentalHealth: "Santé Mentale",
    shareOfRiseProjects: "Part des Projets RISE",
    focusAreas: "Domaines d'Intervention",
    keyInitiatives: "Initiatives Clés",
    fiiWeight: "Poids FII",
    smeSupport: "Soutien aux PME, microfinance, accès au marché",
    skillsTraining: "Formation aux compétences, programmes d'emploi",
    awarenessSupport: "Campagnes de sensibilisation, services de soutien",
    // RISE Economic Recovery Initiatives
    businessTraining: "Formation commerciale",
    microfinanceLinkage: "Liaison microfinance",
    marketAccess: "Accès au marché",
    // RISE Workforce Initiatives
    stemTraining: "Formation STEM",
    digitalSkills: "Compétences numériques",
    apprenticeships: "Apprentissages",
    // RISE Mental Health Initiatives
    supportGroups: "Groupes de soutien",
    schoolWellnessPrograms: "Programmes de bien-être scolaire",
    hotlines: "Lignes d'aide",
    // FII Weight Labels
    entrepreneurship: "entrepreneuriat",
    workforce: "main-d'œuvre",
    mentalHealthWeight: "santé mentale",
    regionalProjectDistribution: "Distribution Régionale des Projets",
    largestVolume: "Plus Grand Volume",
    rapidGrowth: "Croissance Rapide",
    consolidating: "En Consolidation",
    qualityFocus: "Focus Qualité",
    strategicOpportunity: "Opportunité Stratégique",
    strategicOpportunityText: "L'Amérique et l'Europe ne représentent que 11% des projets mais ont une infrastructure solide pour RISE. Envisagez une expansion ciblée.",
    sdgAlignmentMatrix: "Matrice d'Alignement ODD",
    sdgsAddressed: "12 ODD Adressés",
    riseProjectsAddress: "Les projets RISE adressent 12 des 17 ODD de l'ONU",
    primaryFocusAreas: "Domaines d'Intervention Primaires",
    allSdgsCoverage: "Couverture de Tous les ODD",
    primaryFocus: "Focus Primaire",
    crossCutting: "Transversal",
    sizeProjectCount: "Nombre de Projets",
    resourcesMobilized: "Ressources Mobilisées",
    total: "Total",
    totalResourceMobilization: "Mobilisation Totale des Ressources",
    estimatedValue: "Valeur économique estimée générée",
    resourceBreakdown: "Répartition des Ressources",
    volunteer: "Valeur du Bénévolat",
    volunteerHoursValue: "Valeur des Heures de Bénévolat",
    corporate: "Partenaires Corporatifs",
    corporatePartnerships: "Partenariats Corporatifs",
    grantsFoundations: "Subventions et Fondations",
    hoursAtStandardRate: "435 605 heures au taux standard",
    hoursAtStandardRates: "heures aux taux standards",
    globalCorporatePar: "Partenariats corporatifs mondiaux",
    globalCorporatePartners: "Partenaires corporatifs mondiaux",
    foundationSupport: "Soutien des fondations et subventions",
    efficiencyMetrics: "Métriques d'Efficacité",
    costPerBeneficiary: "Coût par Bénéficiaire",
    volunteerROI: "ROI du Bénévolat",
    partnerRetention: "Rétention des Partenaires",
    highlyEfficient: "Hautement Efficace",
    forEveryDollar: "Pour chaque dollar investi",
    yearOverYear: "D'année en année",
    virtualEvent: "Événement Virtuel",
    globalYouthDialogue: "Dialogue Mondial de la Jeunesse",
    dialogueDate: "24 Septembre 2025",
    theme: "Thème",
    youthLeadershipUncertainty: "Leadership Jeunesse en Temps d'Incertitude",
    globalYouthLeaders: "Leaders Jeunes Mondiaux",
    continents: "Continents",
    registrants: "Inscrits",
    liveAttendees: "Participants en Direct",
    fbLiveViewers: "Spectateurs FB Live",
    totalReach: "Portée Totale",
    comments: "Commentaires",
    shares: "Partages",
    reactions: "Réactions",
    eventOutcomes: "Résultats de l'Événement",
    leadershipTrainingHours: "Heures de Formation au Leadership",
    certificatesIssued: "Certificats Émis",
    businessPartnerships: "Partenariats d'Affaires",
    mentorshipRelationships: "Relations de Mentorat",
    riseProjectsCommissioned: "Projets RISE Commandés",
    mediaImpressions: "Impressions Médias",
    genderDistribution: "Répartition par Genre",
    male: "Homme",
    female: "Femme",
    nonBinary: "Non-Binaire",
    attendanceType: "Type de Participation",
    events20242025: "Événements 2024-2025",
    repeatAttendees: "Participants Récurrents",
    firstTime: "Première Fois",
    firstTimeRecruitment: "Opportunité clé de recrutement!",
    conferencesMap: "Carte des Conférences",
    areaConferencesWorldCongress: "Conférences de Zone et Congrès Mondial",
    events: "Événements",
    resetView: "Réinitialiser la Vue",
    worldCongress: "Congrès Mondial",
    areaConference: "Conférence de Zone",
    expected: "prévu",
    openInGoogleMaps: "Ouvrir dans Google Maps",
    participants: "participants",
    teams: "équipes",
    prizeMoney: "Prix en Espèces",
    largest: "Plus Grand",
    top: "Top",
    impact: "Impact",
    winnerProfile: "Profil du Gagnant",
    averageAge: "Âge Moyen",
    femaleFounders: "Fondatrices Féminines",
    participationByConference: "Participation par Conférence",
    curriculumAreas: "Domaines du Curriculum",
    outcomes: "Résultats",
    partnerNetwork: "Réseau de Partenaires",
    new: "NOUVEAU",
    learnMore: "En Savoir Plus",
    lessDetails: "Moins de Détails"
  },
  programDetailData: {
    cyeObjective: "Développer les jeunes entrepreneurs par des concours d'innovation",
    cyeImpact1: "108 entrepreneurs de 20+ pays ont participé",
    cyeImpact2: "Plus de 10 000 $ en prix décernés",
    cyeImpact3: "35% des participants étaient des fondatrices féminines",
    cyeImpact4: "40% dans le secteur tech, diversifiant les industries",
    cyeImpact5: "Connexions de mentorat et de réseautage établies",
    services: "Services",
    other: "Autre",
    cyeGeography: "Distribution mondiale dans les 4 zones JCI",
    cyeFiiAlignment: "Soutient les dimensions de reprise économique et d'entrepreneuriat du FII",
    jibObjective: "Développement professionnel et réseautage d'affaires",
    jibCurriculum1: "Innovation et Stratégie d'Affaires",
    jibCurriculum2: "Gestion Financière",
    jibCurriculum3: "Accès au Marché Mondial",
    jibCurriculum4: "Excellence en Leadership",
    jibCurriculum5: "Santé Mentale en Affaires",
    jibOutcome1: "Ont signalé des compétences commerciales améliorées",
    jibOutcome2: "Ont élargi leur réseau professionnel",
    jibOutcome3: "Ont lancé de nouvelles initiatives commerciales",
    jibOutcome4: "Ont augmenté leur confiance en leadership",
    jibOutcome5: "Ont appliqué des pratiques de bien-être mental",
    growingRapidly: "Croissance Rapide",
    globalMentors: "Mentors Mondiaux",
    angelInvestors: "Investisseurs Providentiels",
    vcNetworks: "Réseaux VC",
    jibFiiAlignment: "S'aligne avec les dimensions de main-d'œuvre et économiques du FII",
    fiiAlignment: "Alignement FII",
    publicSpeakingName: "Concours de Prise de Parole",
    publicSpeakingObjective: "Développe la confiance et l'excellence en communication",
    psTopic1: "Jeunesse et Action Climatique",
    psTopic2: "Leadership dans l'Incertitude",
    psTopic3: "Impact de la Transformation Numérique",
    psTopic4: "Construction de la Résilience Communautaire",
    psSkill1: "Communication Verbale",
    psSkill2: "Pensée Critique",
    psSkill3: "Renforcement de la Confiance",
    psSkill4: "Conscience Interculturelle",
    psSkill5: "Présence de Leadership",
    reportIncreasedConfidence: "signalent une confiance accrue",
    equalParticipation: "Participation Égale",
    psFiiAlignment: "Améliore la préparation de la main-d'œuvre par les compétences de communication",
    debatingName: "Championnat de Débat",
    debatingObjective: "Concours de débat multilingue favorisant la pensée critique",
    english: "Anglais",
    french: "Français",
    spanish: "Espagnol",
    debateSkill1: "Raisonnement Analytique",
    debateSkill2: "Argumentation Structurée",
    debateSkill3: "Compétences de Recherche",
    debateSkill4: "Conscience Mondiale",
    debateSkill5: "Excellence Académique",
    debateFormat: "Format de Débat des Écoles Mondiales",
    debateFiiAlignment: "Développe la pensée critique pour la préparation de la main-d'œuvre",
    debateImpact1: "Pensée analytique améliorée",
    debateImpact2: "Prise de parole améliorée",
    debateImpact3: "Compétences en méthodologie de recherche",
    debateImpact4: "Compréhension interculturelle"
  },
  sdgs: {
    noPoverty: "Pas de Pauvreté",
    zeroHunger: "Faim Zéro",
    goodHealth: "Bonne Santé et Bien-être",
    qualityEducation: "Éducation de Qualité",
    genderEquality: "Égalité entre les Sexes",
    cleanWater: "Eau Propre et Assainissement",
    affordableEnergy: "Énergie Propre et Abordable",
    decentWork: "Travail Décent et Croissance Économique",
    industryInnovation: "Industrie, Innovation et Infrastructure",
    reducedInequalities: "Inégalités Réduites",
    sustainableCities: "Villes et Communautés Durables",
    responsibleConsumption: "Consommation et Production Responsables",
    climateAction: "Action Climatique",
    lifeBelowWater: "Vie Aquatique",
    lifeOnLand: "Vie Terrestre",
    peaceJustice: "Paix, Justice et Institutions Efficaces",
    partnerships: "Partenariats pour les Objectifs"
  },
  programsShowcase: { title: "Programmes et Événements Phares", subtitle: "Données d'impact réel du Rapport d'Impact JCI 2025", coreInitiative: "Initiative Principale", riseDesc: "Reconstruire, Inspirer, Soutenir et Autonomiser les communautés", projects: "Projets", beneficiaries: "Bénéficiaires", volunteerHours: "Heures de Bénévolat", risePillarsDistribution: "Distribution des Piliers RISE", economicRecovery: "Reprise Économique", workforceReadiness: "Préparation de la Main-d'œuvre", mentalHealth: "Santé Mentale", cye: "Creative Young Entrepreneur (CYE)", cyeDesc: "Concours régional d'entrepreneuriat", jib: "JCI in Business (JIB)", jibDesc: "Programme de réseautage et développement d'affaires", publicSpeaking: "Concours de Prise de Parole", publicSpeakingDesc: "Développe la confiance et les compétences de communication", debating: "Championnat de Débat", debatingDesc: "Concours de débat multilingue", english: "Anglais", french: "Français", spanish: "Espagnol", totalParticipants: "Total des Participants", totalTeams: "Total des Équipes", prize: "Prix", teams: "équipes", areaConferences2025: "Conférences de Zone 2025", asiaPacificConference: "Conférence Asie-Pacifique", europeConference: "Conférence Europe", africaMeConference: "Conférence Afrique & ME", americasConference: "Conférence Amériques", attendees: "Participants", firstTimers: "nouveaux venus", featuredEvent: "Événement en Vedette", globalYouthDialogue: "Dialogue Mondial de la Jeunesse 2025", registrants: "Inscrits", liveAttendees: "Participants en Direct", fbLiveViewers: "Spectateurs FB Live", chatMessages: "Messages de Chat", jciSenators: "Sénateurs JCI", senatorsNew: "84 nouveaux en 2025", toypRecognized: "TOYP Reconnu", toypCategories: "10 catégories", peopleImpacted: "Personnes Impactées", throughAllPrograms: "À travers tous les programmes", sourceNote: "Rapport d'Impact JCI 2025 - Données officielles de programmes et événements" },
  sdgAlignment: { title: "Alignement ODD", subtitle: "Programmes JCI mappés aux Objectifs de Développement Durable de l'ONU", sdgCount: "ODD Couverts", sdgCountDesc: "Les programmes JCI contribuent à 12 des 17 ODD de l'ONU", primaryGoals: "Objectifs Principaux", primaryGoalsDesc: "Les plus impactés par les initiatives JCI", goodHealth: "Bonne Santé et Bien-être", qualityEducation: "Éducation de Qualité", decentWork: "Travail Décent et Croissance Économique", reducedInequalities: "Inégalités Réduites", partnerships: "Partenariats pour les Objectifs", impactMapping: "Cartographie d'Impact", riseProjects: "Projets RISE", riseProjectsDesc: "Aligné avec santé mentale, main-d'œuvre et reprise économique", cyeProgram: "Programme CYE", cyeDesc: "Soutient l'entrepreneuriat et l'innovation", jibProgram: "Programme JIB", jibDesc: "Favorise les compétences commerciales et les réseaux professionnels", toyp: "TOYP", toypDesc: "Reconnaît le leadership et l'impact des jeunes", sourceNote: "Source: Rapport d'Impact JCI 2025 - Méthodologie d'alignement ODD" },
  impactMetricsTitle: "Métriques d'Impact",
  impactMetricsSubtitle: "Mesurer la portée mondiale de JCI et l'impact communautaire",
  riseTitle: "Initiative RISE",
  riseSubtitle: "Reconstruire, Inspirer, Soutenir et Autonomiser les communautés",
  cyeTitle: "Creative Young Entrepreneurs (CYE)",
  cyeSubtitle: "Concours régional d'entrepreneuriat",
  jibTitle: "JCI in Business (JIB)",
  jibSubtitle: "Réseautage d'affaires et développement professionnel",
  debatingTitle: "Championnat de Débat",
  debatingSubtitle: "Concours de débat multilingue favorisant la pensée critique",
  publicSpeakingTitle: "Concours de Prise de Parole",
  publicSpeakingSubtitle: "Développer la confiance et les compétences de communication",
  conferencesTitle: "Conférences de Zone",
  conferencesSubtitle: "Rassemblements régionaux annuels pour le réseautage et la formation",
  rise: { title: "Initiative JCI RISE", subtitle: "Reconstruire, Inspirer, Soutenir et Autonomiser les communautés", totalProjects: "Total des Projets RISE", beneficiariesReached: "Bénéficiaires Atteints", volunteerHours: "Heures de Bénévolat", budgetMobilized: "Budget Mobilisé", pillarDistribution: "Distribution des Piliers", mentalHealth: "Santé Mentale", workforceReadiness: "Préparation de la Main-d'œuvre", economicRecovery: "Reprise Économique", regionalBreakdown: "Répartition Régionale", projectsByRegion: "Projets par Région", topProjects: "Principaux Projets RISE par Impact", viewFullReport: "Voir le Rapport RISE Complet" },
  cye: { title: "Creative Young Entrepreneurs (CYE)", subtitle: "Concours régional d'entrepreneuriat favorisant l'innovation", participants: "Total des Participants", teams: "Total des Équipes", prizePool: "Pool Total des Prix", winnersTitle: "Gagnants 2024", categories: "Catégories de Compétition", socialEnterprise: "Entreprise Sociale", techInnovation: "Technologie et Innovation", greenBusiness: "Entreprise Verte", traditionalBusiness: "Entreprise Traditionnelle", impactMetrics: "Métriques d'Impact", businessesLaunched: "Entreprises Lancées", jobsCreated: "Emplois Créés", fundingSecured: "Financement Obtenu" },
  jib: { title: "JCI in Business (JIB)", subtitle: "Développement professionnel et programme de réseautage d'affaires", activeMembers: "Membres JIB Actifs", networkingEvents: "Événements de Réseautage", businessPartnerships: "Partenariats d'Affaires", benefits: "Avantages JIB", professionalNetwork: "Accès au réseau professionnel", businessSkills: "Développement des compétences commerciales", mentorship: "Opportunités de mentorat", careerAdvancement: "Soutien à l'avancement de carrière", focusAreas: "Domaines d'Intervention", leadership: "Développement du Leadership", networking: "Réseautage d'Affaires", skills: "Compétences Professionnelles", entrepreneurship: "Soutien à l'Entrepreneuriat" },
  debating: { title: "Championnat de Débat JCI", subtitle: "Concours de débat multilingue favorisant la pensée critique", totalTeams: "Total des Équipes", languages: "Langues", countries: "Pays Participants", format: "Format de Compétition", preliminaryRounds: "Tours Préliminaires", semifinals: "Demi-finales", grandFinal: "Grande Finale", skillsDeveloped: "Compétences Développées", criticalThinking: "Pensée Critique", publicSpeaking: "Prise de Parole", research: "Recherche et Analyse", teamwork: "Travail d'Équipe et Collaboration", recentChampions: "Champions Récents", viewHighlights: "Voir les Moments Forts du Débat" },
  publicSpeaking: { title: "Concours de Prise de Parole", subtitle: "Développer la confiance et l'excellence en communication", participants: "Total des Participants", countries: "Pays Participants", speechTopics: "Sujets de Discours", improvisation: "Prise de Parole Impromptu", prepared: "Discours Préparé", persuasive: "Discours Persuasif", competencies: "Compétences Évaluées", delivery: "Prestation et Présence", content: "Contenu et Structure", impact: "Impact et Persuasion", languageProficiency: "Maîtrise de la Langue", recentWinners: "Gagnants Récents", watchSpeeches: "Regarder les Discours Gagnants" },
  conferences: { title: "Conférences de Zone JCI", subtitle: "Rassemblements régionaux annuels pour le réseautage, la formation et le leadership", totalAttendees: "Total des Participants (2025)", conferences: "Conférences", firstTimers: "Participants pour la Première Fois", countries: "Pays Représentés", conferenceHighlights: "Moments Forts de la Conférence", keynotes: "Conférenciers Principaux", workshops: "Ateliers de Formation", networking: "Sessions de Réseautage", awards: "Prix et Reconnaissance", upcomingConferences: "Prochaines Conférences 2025", registerNow: "S'inscrire Maintenant", viewSchedule: "Voir le Programme" },
  toyp: { title: "Ten Outstanding Young Persons (TOYP)", subtitle: "Reconnaître les jeunes leaders exceptionnels dans le monde", recognizedLeaders: "Leaders Reconnus (2025)", categories: "Catégories de Prix", nominationsOpen: "Période de Nominations", categoryList: { businessEconomic: "Accomplissement Commercial et Économique", humanitarian: "Service Humanitaire et Bénévole", science: "Leadership et Accomplissement Académique", political: "Affaires Politiques, Juridiques et Gouvernementales", cultural: "Accomplissement Culturel", medical: "Innovation Médicale", environmental: "Leadership Environnemental", world: "Paix Mondiale et Droits de l'Homme", children: "Bien-être et Éducation des Enfants", personal: "Amélioration et Accomplissement Personnel" }, selectionProcess: "Processus de Sélection", nomination: "Nomination", evaluation: "Évaluation", recognition: "Reconnaissance", pastHonorées: "Anciens Lauréats TOYP", submitNomination: "Soumettre une Nomination" },
  programMetrics: { title: "Métriques de Participation aux Programmes", subtitle: "Engagement des membres dans les programmes JCI", totalParticipants: "Total des Participants au Programme", programReach: "Portée du Programme par Région", growthTrend: "Croissance d'Année en Année", satisfactionScore: "Satisfaction des Participants", highRating: "Note Élevée", repeatParticipation: "Participation Répétée", likelyToRecommend: "Susceptible de recommander", topPerformingPrograms: "Programmes les Plus Performants", program: "Programme", participants: "Participants", satisfaction: "Satisfaction", growth: "Croissance" },
  programImpact: { title: "Évaluation de l'Impact du Programme", subtitle: "Mesurer les résultats et l'impact à long terme", skillsDevelopment: "Développement des Compétences", reportImprovedSkills: "Signalent des compétences de leadership améliorées", networkGrowth: "Croissance du Réseau", expandedNetwork: "Ont élargi leur réseau professionnel", careerAdvancement: "Avancement de Carrière", careerProgress: "Attribuent leur progression de carrière à JCI", communityImpact: "Impact Communautaire", ledCommunityProjects: "Ont dirigé ou participé à des projets communautaires", impactStories: "Histoires d'Impact", readStories: "Lire les Histoires des Membres", shareYourStory: "Partagez Votre Histoire" },
  humanDuties: {
    title: "Initiative Internationale des Devoirs Humains",
    headline: "67 101 Voix Mondiales pour le Leadership Éthique",
    heroDescription: "L'Initiative Internationale des Devoirs Humains représente un changement fondamental dans le discours mondial sur le leadership. Alors que les droits humains sont largement reconnus, le concept complémentaire des devoirs humains reste sous-exploré. JCI mène cette conversation à travers la Déclaration Universelle des Devoirs Humains pour les Leaders.",
    totalPetitions: "Total des Pétitions Signées",
    globalSignatories: "signataires mondiaux",
    geographicCoverage: "Couverture Géographique",
    countriesAcross: "pays dans 4 régions",
    nationalAmbassadors: "Ambassadeurs Nationaux",
    leadingCoordination: "coordonnant IHDD",
    regionalBreakdown: "Répartition Régionale",
    region: "Région",
    petitionsSigned: "Pétitions Signées",
    percentGlobal: "% du Global",
    asiaPacific: "Asie et le Pacifique",
    africaMiddleEast: "Afrique et Moyen-Orient",
    americas: "Amérique",
    europe: "Europe",
    highMomentum: "Fort momentum",
    growingActivities: "En croissance (19 activités)",
    establishedBase: "Base établie",
    emerging: "Émergent",
    keyMilestones: "Jalons Institutionnels Clés",
    nelsonMandelaEndorsement: "Approbation de la Fondation Nelson Mandela",
    mandelaDesc: "Reconnaissance officielle de l'Initiative des Devoirs Humains (2025)",
    legislativeSuccess: "Succès Législatif",
    legislativeDesc: "L'État de Zulia (Venezuela) a promulgué la Loi sur les Devoirs Humains, déclaré le 10 juillet Journée Internationale des Devoirs Humains (2025)",
    ihddImpact: "Impact de la Journée Internationale des Devoirs Humains (IHDD)",
    reportedActivities: "Activités Signalées 2025",
    sevenDutiesFramework: "Les 7 Devoirs pour les Leaders",
    duty1: "Devoir de Défendre la Dignité Humaine",
    duty2: "Devoir de Servir le Bien Commun",
    duty3: "Devoir de Protéger l'Environnement",
    duty4: "Devoir de Promouvoir l'Équité et la Justice",
    duty5: "Devoir de Favoriser la Paix et la Compréhension",
    duty6: "Devoir de Soutenir l'Éducation et le Développement",
    duty7: "Devoir d'Agir avec Intégrité et Responsabilité",
    ctaTitle: "Faites Partie du Mouvement",
    signPetition: "Signer la Pétition",
    becomeAmbassador: "Devenir Ambassadeur National",
    viewStories: "Voir les Histoires IHDD",
    sourceNote: "Source: Rapport d'Impact JCI 2025 – Données de l'Initiative des Devoirs Humains"
  },
  strategicPartnerships: {
    title: "Partenariats Stratégiques Mondiaux",
    headline: "Construire des Ponts: Partenariats Stratégiques Mondiaux de JCI",
    heroDescription: "L'impact de JCI est amplifié grâce à des partenariats stratégiques avec des organisations mondiales qui partagent notre engagement à développer les jeunes leaders et à faire avancer le développement durable.",
    activePartnership: "Partenariat actif",
    growingPartnership: "Partenariat en croissance",
    emergingPartnership: "Partenariat émergent",
    infrastructurePartner: "Partenaire d'infrastructure",
    partnershipTiers: "Niveaux de Partenariat",
    tier1Active: "Niveau 1: Partenariats Actifs",
    tier2Growing: "Niveau 2: Partenariats en Croissance",
    tier3Emerging: "Niveau 3: Partenariats Émergents",
    tier4Infrastructure: "Niveau 4: Partenaires d'Infrastructure",
    roiIndicators: "Indicateurs de ROI du Partenariat",
    partner: "Partenaire",
    memberBenefit: "Bénéfice pour les Membres",
    orgBenefit: "Bénéfice Organisationnel",
    effortLevel: "Niveau d'Effort",
    roiTimeline: "Calendrier de ROI",
    low: "Faible",
    medium: "Moyen",
    veryLow: "Très Faible",
    immediate: "Immédiat",
    threeMonths: "3 mois",
    sixMonths: "6 mois",
    oneYear: "1 an",
    iccName: "Chambre de Commerce Internationale (ICC)",
    unName: "Nations Unies (ONU)",
    unescoName: "UNESCO",
    worldBankName: "Banque Mondiale / IFC",
    wefName: "Forum Économique Mondial (WEF)",
    aiesecName: "AIESEC",
    bniName: "BNI (Business Network International)",
    wbafName: "Forum de l'Alliance des Femmes d'Affaires (WBAF)",
    zohoName: "Zoho",
    gyefName: "Forum Économique Mondial de la Jeunesse (GYEF)",
    ctaTitle: "Rejoignez le Réseau de Partenaires",
    viewAllPartnerships: "Voir Tous les Partenariats",
    partnerWithJCI: "Partenariat avec JCI",
    accessResources: "Accéder aux Ressources des Partenaires",
    sourceNote: "Source: Rapport d'Impact JCI 2025 – Partenariats Stratégiques"
  }
} as const;
